import React from 'react';

//Creates loading modal
const Loading = () => {
    return (
        <div id="loading">
            <h2 className="message">Search...</h2>
        </div>
    )
}


export default Loading;